/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Formik } from 'formik';
import { GlobalAuthContext } from 'store/context';
import { LoaderContext } from '@fitinsur/contexts';
import { useTextMessage } from '@fitinsur/hooks';
import { FitinsurAPI, MessageCenter } from '@fitinsur/utils';
import {
  Button,
  ButtonContainer,
  FormSectionGlobal as FormSection,
  FormContainer,
  HasPermission,
  Icon,
  Label,
  ModalConfirmation,
  ResponsiveTable,
} from '@fitinsur/components';
import Layout from 'components/Layout';
import { ButtonContent } from './sectionHandlers/person/components/styles';
import { CheckUsernameButton } from './styles';
import { useGeCheckPersonByLegalPersonId, useUpdateAdminPersonOperation, useCheckUsername } from '@fitinsur/services/AdminService';
import { useGetOperationAsync, useCheckBorrowerHasCreditAnalysis } from '@fitinsur/services/OperationService';
import { useGetQuestionnairesByIdProduct } from '@fitinsur/services/QuestionnairesService';
import { useGetPlanCoveragePersonByIdPerson } from '@fitinsur/services/PlanCoveragePersonService';
import { useGetPersonsSync, useGetPersonByLegalPersonIdAndOwner, usePersonExpire, usePersonRestore } from '@fitinsur/services/PersonService';
import { useCreateContact, useUpdateContact, useExpireContact } from '@fitinsur/services/ContactService';
import { useGetProductPlans } from '@fitinsur/services/ProductPlanService';
import { useExpireUser, useGetUserByPerson, useGetAllUsers } from '@fitinsur/services/UserService';
import { useGetPersonRelationships } from '@fitinsur/services/PersonRelationshipsService';
import { useGetAccessGroups } from '@fitinsur/services/AccessGroupService';
import { useCreateAccessGroupMembership, useGetAccessGroupMembership, useExpireAccessGroupMembership, } from '@fitinsur/services/AccessGroupMembershipService';
import { generalHandler, personHandler } from './sectionHandlers';
import { components } from './sectionHandlers/person/components';

export default function ManagementEditPerson({ permissions, match, ...props }) {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const fitinsurAPI = new FitinsurAPI();
  const mc = new MessageCenter();
  const { getDescription } = useTextMessage();
  const formikRef = useRef();
  const getQuestionnaire = useRef(false);
  const sentUpdateAdminOperation = useRef(false);
  const [idPerson, setIdPerson] = useState(match?.params?.idPerson || null);
  const [idOperation, setIdOperation] = useState(match?.params?.idOperation || null);
  const [borrowerCcgIdOperation, setBorrowerCcgIdOperation] = useState(null);
  const [isBrokerRelationship, setIsBrokerRelationship] = useState(false);
  const [personData, setPersonData] = useState(null);
  const [planCoveragePersonData, setPlanCoveragePersonData] = useState(null);
  const [operation, setOperation] = useState(null);
  const [parentPersonData, setParentPersonData] = useState(null);
  const [productPlansData, setProductPlansData] = useState(null);
  const [personType, setPersonType] = useState(null);
  const [selectedAccessGroupMembership, setSelectedAccessGroupMembership] = useState(null);
  const [forceLoading, setForceLoading] = useState(false);
  const [isBound, setIsBound] = useState(false);
  const [showBorrowerInfoSection, setShowBorrowerInfoSection] = useState(false);
  const [showProductPlansSection, setShowProductPlansSection] = useState(false);
  const [editContact, setEditContact] = useState(false);
  const [addContact, setAddContact] = useState(false);
  const [disableSaveContact, setDisableSaveContact] = useState(false);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [productPlansGroup, setProductPlansGroup] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [isRestore, setIsRestore] = useState(false);
  const [isUsernameAvailable, setIsUsernameAvailable] = useState(false);
  const [users, setUsers] = useState([]);
  const [accessGroups, setAccessGroups] = useState([]);
  const [renderAccessGroupsTable, setRenderAccessGroupsTable] = useState(false);
  const [user, setUser] = useState(null);
  const [selectedContact, setSelectedContact] = useState({});
  const [dialogConfirmation, setDialogConfirmation] = useState({ visible: false });
  const [individual, setIndividual] = useState(false);
  const isNotDisable = useRef(true);
  const [modalConfirmationDetails, setModalConfirmationDetails] = useState({
    text: null,
    textButtonConfirm: null,
    textButtonCancel: null,
    type: null,
  });

  const pathname = new URL(window.location.href).pathname;
  const isEditing = pathname.includes('edit');
  const isCreating = pathname.includes('create');
  const addingUser = pathname.includes('add-user');

  const SECTIONS = {
    USER_ACCESS_GROUP: { name: 'USER_ACCESS_GROUP', isMultiple: false, isRisk: false },
    BORROWER_INFO: { name: 'BORROWER_INFO', isMultiple: false, isRisk: false },
    PERSON: { name: 'PERSON', isMultiple: false, isRisk: false },
    PERSON_CONTACT: { name: 'PERSON_CONTACT', isMultiple: false, isRisk: false },
    PRODUCT_PLAN: { name: 'PRODUCT_PLAN', isMultiple: true, isRisk: false },
    LGPD: { name: 'LGPD', isMultiple: false, isRisk: false },
  };

  const contactColumnsProps = {
    setDialogConfirmation,
    setEditContact,
    setAddContact,
    setSelectedContact,
    setMainContact,
    setModalConfirmationDetails,
    questionnaire,
    personHandler,
    getDescription,
    setQuestionnaire,
    user,
  };

  const userColumnsProps = {
    history,
    setDialogConfirmation,
    setModalConfirmationDetails,
    getDescription,
    setSelectedUser,
    setIsRestore,
    permissions,
    idPerson: match?.params?.idPerson 
  };

  const accessGroupColumnsProps = {
    history,
    getDescription,
    setDialogConfirmation,
    setModalConfirmationDetails,
    handleSetAcessGroup,
  };

  const {
    loading: useGetOperationLoading,
    request: useGetOperationRequest,
  } = useGetOperationAsync(match.params.idOperation);

  const {
    loading: useGeCheckPersonByLegalPersonIdLoading,
    request: useGeCheckPersonByLegalPersonIdRequest,
  } = useGeCheckPersonByLegalPersonId();

  const {
    loading: useCheckUsernameLoading,
    request: useCheckUsernameRequest,
  } = useCheckUsername();

  const {
    loading: useUpdateAdminOperationLoading,
    request: useUpdateAdminOperationRequest,
  } = useUpdateAdminPersonOperation();

  const {
    data: useGetQuestionnairesByIdProductData,
    loading: useGetQuestionnairesByIdProductLoading,
    status: useGetQuestionnairesByIdProductStatus,
    request: useGetQuestionnairesByIdProductRequest,
  } = useGetQuestionnairesByIdProduct(match.params.idProduct);

  const {
    loading: useGetPlanCoveragePersonByIdPersonLoading,
    request: useGetPlanCoveragePersonByIdPersonRequest,
  } = useGetPlanCoveragePersonByIdPerson(match.params.idPerson);

  const {
    loading: useGetProductPlansLoading,
    request: useGetProductPlansRequest,
  } = useGetProductPlans();

  const {
    loading: useGetPersonsSyncLoading,
    request: useGetPersonsSyncRequest,
  } = useGetPersonsSync();

  const {
    loading: useGetPersonRelationshipsLoading,
    request: useGetPersonRelationshipsRequest,
  } = useGetPersonRelationships(idPerson);

  const {
    loading: useCreateContactLoading,
    request: useCreateContactRequest,
  } = useCreateContact(idPerson);

  const {
    loading: useUpdateContactLoading,
    request: useUpdateContactRequest,
  } = useUpdateContact(idPerson, selectedContact?.idContact);

  const {
    loading: useExpireContactLoading,
    request: useExpireContactRequest,
  } = useExpireContact(idPerson, selectedContact?.idContact);

  const {
    loading: useGetAllUsersLoading,
    request: useGetAllUsersRequest,
  } = useGetAllUsers(match.params.idPerson || idPerson);

  const {
    loading: usePersonExpireLoading,
    request: usePersonExpireRequest,
  } = usePersonExpire(selectedUser?.idPerson);

  const {
    loading: usePersonRestoreLoading,
    request: usePersonRestoreRequest,
  } = usePersonRestore(selectedUser?.idPerson);

  const {
    loading: useGetUserByPersonLoading,
    request: useGetUserByPersonRequest,
  } = useGetUserByPerson(idPerson);

  const {
    loading: useGetPersonByLegalPersonIdLoading,
    request: useGetPersonByLegalPersonIdRequest,
  } = useGetPersonByLegalPersonIdAndOwner();

  const {
    loading: useCreateAccessGroupMembershipLoading,
    request: useCreateAccessGroupMembershipRequest,
  } = useCreateAccessGroupMembership();

  const {
    loading: useGetAccessGroupMembershipLoading,
    request: useGetAccessGroupMembershipRequest,
  } = useGetAccessGroupMembership();

  const {
    loading: useExpireAccessGroupMembershipLoading,
    request: useExpireAccessGroupMembershipRequest,
  } = useExpireAccessGroupMembership(selectedAccessGroupMembership);

  const {
    loading: useGetAccessGroupsLoading,
    request: useGetAccessGroupsRequest,
  } = useGetAccessGroups();

  const {
    loading: useCheckBorrowerHasCreditAnalysisLoading,
    request: useCheckBorrowerHasCreditAnalysisRequest,
  } = useCheckBorrowerHasCreditAnalysis();

  async function getProductPlansData() {
    try {
      fitinsurAPI.setAuthTokenByParam(authContext.token);
      const productListResponse = await fitinsurAPI.requestProductsListSiteOwner();
      const productList = await productListResponse.json();

      if (productList.ret_code !== 200) return;

      const options = productList.ret_value.map(product => ({
        label: product.PRODUCT_NAME,
        value: product.ID_PRODUCT,
      }));

      setProductsData(options);

      const idsProduct = options.map(product => product.value);
      const getProductPlansResponse = await useGetProductPlansRequest(null, { idsProduct });

      if (getProductPlansResponse.status === 200) {
        setProductPlansData(getProductPlansResponse.data.value);
        await getQuestionnaireData();
      }
    } catch (err) {
      mc.error(err);
    }
  }

  async function fetchPersonData(setDataCallback, id) {
    if (!id) return;

    try {
      setForceLoading(true);
      fitinsurAPI.setAuthTokenByParam(authContext.token);
      const response = await fitinsurAPI.requestGetPersonsInfoWithTailRelationship(id);
      const { ret_value } = await response.json();
      setIsBrokerRelationship(ret_value.personRelationships && ret_value.personRelationships[290] ? true : false);
      setDataCallback(ret_value);
    } catch (err) {
      mc.error(err);
    } finally {
      setForceLoading(false);
    }
  }

  async function getPersonData() {
    await fetchPersonData(setPersonData, addingUser ? match?.params?.idPersonParent : match?.params?.idPerson);
  }

  async function getParentPersonData() {
    if (addingUser) {
      await fetchPersonData(setParentPersonData, match?.params?.idPersonParent);
    } else {
      const response = await getPersonRelationship({ idPerson: match?.params?.idPerson});

      if (response?.value?.idPerson) await fetchPersonData(setParentPersonData, response?.value?.idPerson);
    }
  }

  async function getPersonRelationship({idPerson}) {
    if (!match.params.idPerson && !idPerson) return null;

    try {
      const { data: { value: relationships } } = await useGetPersonRelationshipsRequest();
      const applicationPersonRoot = authContext?.login_response?.ret_value?.applicationPersonRoot;

      const matchingRelationship = relationships.find(relationship => relationship?.idDomain === '458' &&
        relationship?.idPersonHead === applicationPersonRoot
      );

      if (!matchingRelationship || matchingRelationship.length === 0) return null;

      return {
        idPerson: matchingRelationship.idPersonHead,
        idPersonRelationship: matchingRelationship.idPersonRelationship
      }
    } catch (err) {
      mc.error(err);
    }
  }

  async function getPlanCoveragePersonData() {
    if (!match.params.idPerson) return;

    try {
      const resp = await useGetPlanCoveragePersonByIdPersonRequest();

      if (resp.status === 200) setPlanCoveragePersonData(resp.data.value);
    } catch (err) {
      mc.error(err);
    }
  }

  useEffect(()=> {
      setIsBound((!permissions.CREATE_PERSON && !match.params.idPerson) || ( match.params.idPerson && !permissions.EDIT_PERSON));
  }, [permissions, match.params])

  async function getQuestionnaireData() {
    if (getQuestionnaire.current) return;

    getQuestionnaire.current = true;

    try {

      if (match?.params?.idOperation) {
        const respOperation = await useGetOperationRequest(null, { loadLastDocument: true });
        if (respOperation.status === 200) {
          const { data: { value } } = respOperation;
          setOperation(value);
          setIsBound([].includes(value.idDomainStatus));
        }
      }

      if (match?.params?.idPerson && !addingUser) {
        await useGetQuestionnairesByIdProductRequest(null, { idDomain: 752, idDomainStatus: 452 });
      } else {
        await useGetQuestionnairesByIdProductRequest(null, { idDomain: 752, idDomainStatus: 451 });
      }
    } catch (err) {
      mc.error(err);
    }
  }

  async function getUsers() {
    if (!idPerson || isCreating) return;

    try {
      const { data: { value } } = await useGetAllUsersRequest();
      setUsers(value);
    } catch (err) {
      mc.error(err);
    }
  }

  async function getUserByPerson() {
    try {
      const { data: { value } } = await useGetUserByPersonRequest();

      if (!value) {
        setPersonType('Part');
        return;
      }

      setUser(value);
      setPersonType('User');
      await getAccessGroups(value.idUser);
    } catch (err) {
      mc.error(err);
    }
  }

  async function setMainContact(idContact) {
    try {
      fitinsurAPI.setAuthTokenByParam(authContext.token);
      const response = await fitinsurAPI.requestSetMainContact(idContact);
      const data = await response.json();

      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details);
        return;
      }

      await getContacts();
    } catch (err) {
      mc.error("An error happened, please try again.");
    }
  }

  async function getContacts() {
    if (addingUser || isCreating) return;

    try {
      const { data: { value } } = await useGetPersonsSyncRequest(null, { idPerson, getContacts: true });

      const personContacts = value?.find(person => person.idPerson === Number(idPerson))?.contacts

      if(value?.length) {
        setIndividual(value[0].legalPersonIdType === 'CPF');
      }
      setContacts(personContacts);
    } catch (err) {
      mc.error(err);
    }
  }

  async function createContact(setFieldValue) {
    try {
      const { idPersonRelationship } = await getPersonRelationship({ idPerson });

      const newContactInfo = personHandler.events.handleCreateContact({
        answers: formikRef.current.values['$ANSWERS_PERSON'],
        getDescription,
        setFieldValue,
      });

      newContactInfo.idPersonRelationship = idPersonRelationship;

      setAddContact(false);
      const response = await useCreateContactRequest(newContactInfo);
      if (response.status === 200) personHandler.events.handleContactFields({ questionnaire, setFieldValue })

      await getContacts();
    } catch (err) {
      if (err?.response?.data?.errors?.length) {
        err?.response?.data?.errors.map(error => {
          if (error.message && !error.message.includes('Contact Description')) {
            mc.error(error.message);
          }
        });
      } else {
        mc.error(getDescription('DOMAINS', 990));
      }
    }
  }

  async function updateContact(setFieldValue) {
    try {
      setEditContact(false);
      const response = await useUpdateContactRequest(selectedContact);

      if (response.status === 200) personHandler.events.handleContactFields({ questionnaire, setFieldValue })

      await getContacts();
    } catch (err) {
      mc.error(err);
    }
  }

  async function handleExpireContact() {
    try {
      await useExpireContactRequest();
      await getContacts();
    } catch (err) {
      mc.error(err);
    }
  }

  async function handleUserStatus() {
    try {
      isRestore
        ? await usePersonRestoreRequest()
        : await usePersonExpireRequest();

      await getUsers();
    } catch (err) {
      mc.error(err);
    }
  }

  async function createAccessGroupMembership(idUser, idGroup) {
    return await useCreateAccessGroupMembershipRequest({ idUser, idGroup, idDomain: 306 });
  }

  async function getAccessGroupMembershipId(idUser, idGroup) {
    if (!idUser || !idGroup) return;

    const { data: { value } } = await useGetAccessGroupMembershipRequest(null, { idUser, idGroup });
    const { idGroupMembership } = value?.find(group => group.idGroup === idGroup);
    return idGroupMembership;
  }

  async function getAccessGroups(idUser) {
    if (!idUser) return;

    const { data: { value: groupsMembership } } = await useGetAccessGroupMembershipRequest(null, { idUser });
    const idGroups = groupsMembership?.map(group => group.idGroup);
    const { data: { value } } = await useGetAccessGroupsRequest(idGroups);
    const accessGroups = value?.map(group => ({
      idGroup: group.idGroup,
      groupName: group.groupName,
      behavior: group.behavior,
    }));

    if (accessGroups) {
      setAccessGroups(accessGroups);
      setRenderAccessGroupsTable(true);
    } else {
      setRenderAccessGroupsTable(false);
    }
  }

  async function getBorrowerCcgId() {
    try {
        await useCheckBorrowerHasCreditAnalysisRequest(
            null,
            {
                idPerson: match.params.idPerson
            }
        ).then(
            ({ data: { value } }) => setBorrowerCcgIdOperation(value?.creditAnalysisOperationWithBroker?.idOperation)
        );
    } catch (err) {
      mc.error(err);
    }
  }

  async function handleAddAccessGroupToUser(setFieldValue) {
    try {
      const qstAccesGroup = questionnaire.find(question => question.idQuestion === 1905);

      if (!qstAccesGroup.answerJson) return;

      const { id: idGroup } = JSON.parse(qstAccesGroup.answerJson);
      setFieldValue(qstAccesGroup.key, null);

      if (!idGroup) return;

      const response = await createAccessGroupMembership(user.idUser, idGroup);

      if (response.status === 200) {
        mc.success(getDescription('DOMAINS', 859));
        await getAccessGroups(user?.idUser);
      }
    } catch (err) {
      mc.error(err);
    }
  }

  async function handleSetAcessGroup(idGroup) {
    try {
      if (!idGroup) return;

      const membershipId = await getAccessGroupMembershipId(user?.idUser, idGroup);
      setSelectedAccessGroupMembership(membershipId);
    } catch (err) {
      mc.error(err);
    }
  }

  async function handleRemoveAccessGroup() {
    try {
      const response = await useExpireAccessGroupMembershipRequest();

      if (response?.status === 200) await getAccessGroups(user?.idUser);
    } catch (err) {
      mc.error(err);
    }
  }

  async function handleCheckPersonByLegalPersonId(value, setFieldValue) {
    if (!value || value.length < 11) return;

      useGeCheckPersonByLegalPersonIdRequest(null, { legalPersonId: value })
      .then(({ data: { value } }) => {
        isNotDisable.current = true;
        if (value?.hasRelationship) {
          mc.success(getDescription('DOMAINS', 756));
            setTimeout(() => {
              history.push(
                `/management/58/person/edit/${value.hasRelationship}`
              );
              window.location.reload();
            }, 1000);
        } else if (value) {
          personHandler.events.handleExistingPerson({
            questionnaire,
            setQuestionnaire,
            setFieldValue,
            personData: value,
          });
        }
      })
      .catch ((error) => {
        isNotDisable.current = false;
        mc.error(error);
      })
  }

  async function handleGetUserByNameRequest(userName) {
    if (!userName) return;

    try {
      await useCheckUsernameRequest({}, { userName });

      setDisableSaveContact(false);
      setIsUsernameAvailable(true);
    } catch (err) {
      setDisableSaveContact(true);
      setIsUsernameAvailable(false);

      if (err?.response?.data?.errors?.length) {
        err?.response?.data?.errors.map(error => mc.error(error.message))
      } else {
        mc.error(err);
      }
    }
  }

  async function handleModalConfirmation() {
    if (modalConfirmationDetails.type === 'contact') handleExpireContact();
    if (modalConfirmationDetails.type === 'user') handleUserStatus();
    if (modalConfirmationDetails.type === 'accessGroup') handleRemoveAccessGroup();
    setDialogConfirmation({ visible: false });
  }

  function handleCreateLogin() {
    if (!permissions.CREATE_USER) {
      mc.error(`${getDescription('DOMAINS', 1072)} ${authContext?.login_response?.ret_value?.rootFirstName}`);
    } else {
      history.push(`/management/58/user/create/${idPerson}`);
    }
  }
  
  useEffect(() => {
    getPlanCoveragePersonData();
    getPersonData();
    getParentPersonData();
    getContacts();
    getUsers();
    getUserByPerson();
    getProductPlansData();
    match.params.idPerson && getBorrowerCcgId();
  }, []);

  useEffect(() => {
    if (
      useGetQuestionnairesByIdProductStatus === 200 &&
      ((match.params.idPerson && personData && planCoveragePersonData) || !match.params.idPerson) &&
      productPlansData
    ) {
      generalHandler.events.handleQuestionnaire({
        data: useGetQuestionnairesByIdProductData?.value,
        setQuestionnaire,
        setFieldValue: formikRef?.current?.setFieldValue,
        personData,
        planCoveragePersonData,
        productsData,
        productPlansData,
        setProductPlansGroup,
        setShowBorrowerInfoSection,
        setShowProductPlansSection,
        parentPersonData,
        addingUser,
        user,
        isEditing,
        isBrokerRelationship,
        borrowerCcgIdOperation
      });
    }
  }, [
    useGetQuestionnairesByIdProductStatus,
    useGetQuestionnairesByIdProductData,
    personData,
    productPlansData,
    parentPersonData,
    user,
  ]);

  useEffect(() => {
    personHandler.events.handleQuestionAdjustments({
      questionnaire,
      accessGroups,
    });
  }, [questionnaire, accessGroups]);

  useEffect(() => {
    updateIsLoadingStatus(
        forceLoading ||
        useGetOperationLoading ||
        useGeCheckPersonByLegalPersonIdLoading ||
        useUpdateAdminOperationLoading ||
        useGetQuestionnairesByIdProductLoading ||
        useGetAllUsersLoading ||
        useGetPersonsSyncLoading ||
        useExpireContactLoading ||
        useGetPlanCoveragePersonByIdPersonLoading ||
        useGetProductPlansLoading ||
        useCreateContactLoading ||
        useUpdateContactLoading ||
        usePersonExpireLoading ||
        usePersonRestoreLoading ||
        useGetUserByPersonLoading ||
        useGetPersonByLegalPersonIdLoading ||
        useGetAccessGroupMembershipLoading ||
        useCreateAccessGroupMembershipLoading ||
        useExpireAccessGroupMembershipLoading ||
        useGetAccessGroupsLoading ||
        useGetPersonRelationshipsLoading ||
        useCheckUsernameLoading || 
        useCheckBorrowerHasCreditAnalysisLoading
    );
  }, [
    forceLoading,
    useGetOperationLoading,
    useGeCheckPersonByLegalPersonIdLoading,
    useUpdateAdminOperationLoading,
    useGetQuestionnairesByIdProductLoading,
    useGetAllUsersLoading,
    useGetPersonsSyncLoading,
    useExpireContactLoading,
    useGetPlanCoveragePersonByIdPersonLoading,
    useGetProductPlansLoading,
    useCreateContactLoading,
    useUpdateContactLoading,
    usePersonExpireLoading,
    usePersonRestoreLoading,
    useGetUserByPersonLoading,
    useGetPersonByLegalPersonIdLoading,
    useGetAccessGroupMembershipLoading,
    useCreateAccessGroupMembershipLoading,
    useExpireAccessGroupMembershipLoading,
    useGetAccessGroupsLoading,
    useGetPersonRelationshipsLoading,
    useCheckUsernameLoading,
    useCheckBorrowerHasCreditAnalysisLoading
  ]);

  return (
    <>
      <ModalConfirmation
        show={dialogConfirmation.visible}
        showTitle={false}
        text={modalConfirmationDetails.text}
        textButtonConfirm={modalConfirmationDetails.textButtonConfirm}
        textButtonCancel={modalConfirmationDetails.textButtonCancel}
        onConfirm={handleModalConfirmation}
        onCancel={() => setDialogConfirmation({ visible: false })}
      />
      <Formik innerRef={formikRef} initialValues={{}} validateOnChange={false} validateOnBlur={false} enableReinitialize={true}>
        {({ values, setFieldValue, errors, setFieldError }) => (
          <Layout idOperation={props?.idOperation} title={isEditing ? getDescription('DOMAINS', 805) : values.fullName || getDescription('DOMAINS', 754)}>
            <Form>
              {/* Informações cadastrais da parte */}
              <FormContainer
                enumerate={1}
                noTitlePadding
                title={getDescription('DOMAINS', 755)}
                hide={!generalHandler.events.sectionIsVisible({
                  sectionName: 'PERSON',
                  questionnaire,
                  permissions,
                  currentModality: null,
                  ignoreVisibilityByModality: true,
                })}
              >
                <FormSection
                  setQuestionnaire={setQuestionnaire}
                  sectionName="PERSON"
                  disableAll={isBound}
                  idProduct={match.params.idProduct}
                  values={values}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  setFieldError={setFieldError}
                  questionnaire={questionnaire}
                  ignoreModality
                  permissions={permissions}
                  onRequestSerproCnpj={(question, data, setFieldValue) => {
                    personHandler.events.handleRequestSerproCnpj({
                      question,
                      data,
                      questionnaire,
                      setQuestionnaire,
                      setFieldValue,
                      idPerson: idPerson ?? null,
                    });
                  }}
                  onBlur={async (question, value, setFieldValue, questionnaireUpdated) => {
                    if (question.behaviorObject.fieldMask === 'cpfCnpj') {
                      handleCheckPersonByLegalPersonId(value, setFieldValue);
                    };
                  }}
                  onQuestionChange={async (question, value, setFieldValue, questionnaireUpdated) => {
                    personHandler.events.handleQuestionChange({
                      question,
                      value,
                      questionnaireUpdated,
                      setQuestionnaire,
                      setFieldValue,
                      setProductPlansGroup,
                      setShowProductPlansSection,
                      setShowBorrowerInfoSection,
                      addingUser,
                      mc,
                      idPerson: idPerson ?? null,
                      idOperation: idOperation ?? null,
                      users,
                      history,
                      isCreating,
                      isBrokerRelationship
                    });
                  }}
                />
              </FormContainer>

              {/* Informações de contato */}
              {(idPerson && !addingUser) && (
                <FormContainer
                  enumerate={2}
                  noTitlePadding
                  title={getDescription('DOMAINS', 809)}
                  hide={!generalHandler.events.sectionIsVisible({
                    sectionName: 'PERSON_CONTACT',
                    questionnaire,
                    permissions,
                    currentModality: null,
                    ignoreVisibilityByModality: true,
                  })}
                >
                  {(addContact && !editContact) && (
                    <>
                      <Label fontSize={20} style={{ marginBottom: 15 }}>
                        {getDescription('DOMAINS', 850)}
                      </Label>
                      <FormSection
                        setQuestionnaire={setQuestionnaire}
                        sectionName="PERSON_CONTACT"
                        disableAll={isBound}
                        idProduct={match.params.idProduct}
                        values={values}
                        errors={errors}
                        setFieldValue={setFieldValue}
                        setFieldError={setFieldError}
                        questionnaire={questionnaire}
                        permissions={permissions}
                        onSearchZipCode={(zipCode, setFieldValue, rootQuestion) =>
                          personHandler.events.handleSearchZipCode(rootQuestion, zipCode, questionnaire, setQuestionnaire, setFieldValue)
                        }
                        onQuestionChange={(question, value, setFieldValue, questionnaireUpdated) => {
                          personHandler.events.handleQuestionChange({
                            question,
                            value,
                            questionnaireUpdated,
                            setQuestionnaire,
                            setFieldValue,
                            idPerson: idPerson ?? null,
                            idOperation: idOperation ?? null,
                            users,
                            history,
                            setIsUsernameAvailable
                          });
                        }}
                        extraButtonsQuestion={(question) => {
                          return (
                            <>
                              {question.idQuestion === 1894 && (
                                <div>
                                  <CheckUsernameButton type="button" onClick={() => handleGetUserByNameRequest(values[question.key])}>
                                    <Icon name={isUsernameAvailable ? 'check-ok-true-green' : 'check-ok'} title='Consultar disponibilidade de username' />
                                  </CheckUsernameButton>
                                </div>
                              )}
                            </>
                          )
                        }}
                      />
                    </>
                  )}

                  {isEditing && (
                    <>
                      <Label fontSize={20} style={{ marginBottom: 15 }}>
                        {getDescription('DOMAINS', 810)}
                      </Label>
                      {contacts?.length > 0 ? (
                        <ResponsiveTable
                          columns={components.contactColumns({ ...contactColumnsProps, setFieldValue })}
                          data={contacts}
                          formikRef={formikRef?.current}
                        />
                      ) : (
                        <Label fontSize={15} style={{ marginBottom: 15 }}>
                          {getDescription('DOMAINS', 811)}
                        </Label>
                      )}

                      {editContact && (
                        <>
                          <Label fontSize={20} style={{ marginBottom: 15 }}>
                            {getDescription('DOMAINS', 812)}
                          </Label>
                          <FormSection
                            setQuestionnaire={questionnaire => setQuestionnaire(questionnaire)}
                            sectionName="PERSON_CONTACT"
                            disableAll={false}
                            idProduct={match.params.idProduct}
                            values={values}
                            errors={errors}
                            setFieldValue={setFieldValue}
                            setFieldError={setFieldError}
                            questionnaire={questionnaire}
                            formikRef={formikRef}
                            onSearchZipCode={(zipCode, setFieldValue, rootQuestion) =>
                              personHandler.events.handleSearchZipCode(rootQuestion, zipCode, questionnaire, setQuestionnaire, setFieldValue)
                            }
                            onQuestionChange={(question, value, setFieldValue, questionnaireUpdated) => {
                              personHandler.events.handleQuestionChange({
                                question,
                                value,
                                questionnaireUpdated,
                                setQuestionnaire,
                                setFieldValue,
                                editContact,
                                setSelectedContact,
                                idPerson: idPerson ?? null,
                                idOperation: idOperation ?? null,
                                users,
                                history,
                                setIsUsernameAvailable
                              });
                            }}
                            permissions={permissions}
                          />

                          <ButtonContainer>
                            <ButtonContent>
                              <HasPermission permission={isNotDisable.current}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                  <Button
                                    id="btnCancel"
                                    type="button"
                                    style={{ marginLeft: 'auto' }}
                                    onClick={async () => {
                                      setEditContact(false)
                                      personHandler.events.handleContactFields({ questionnaire, setFieldValue })
                                    }}
                                    primary
                                  >
                                    {getDescription('DOMAINS', 791)}
                                  </Button>
                                  <Button
                                    id="btnSaveContact"
                                    type="button"
                                    style={{ marginLeft: 'auto' }}
                                    onClick={() => {
                                      generalHandler.events.handleContactManagement({
                                        formikRef,
                                        mc,
                                        values,
                                        questionnaire,
                                        idPerson,
                                        idOperation,
                                        SECTIONS,
                                        contacts: [selectedContact],
                                        getDescription,
                                        setFieldValue,
                                        setFieldError,
                                        callback: updateContact,
                                      })
                                    }}
                                    primary
                                  >
                                    {getDescription('DOMAINS', 846)}
                                  </Button>
                                </div>
                              </HasPermission>
                            </ButtonContent>
                          </ButtonContainer>
                        </>
                      )}
                      {!addingUser && !editContact && (
                        <ButtonContainer>
                          <ButtonContent>
                            <HasPermission permission={isNotDisable.current}>
                              {!addContact ? (
                                <Button
                                  id="btnNewContact"
                                  type="button"
                                  onClick={() => {
                                    setAddContact(true);
                                    setEditContact(false);
                                    personHandler.events.handleAddContact({ questionnaire });
                                  }}
                                  disabled={isBound}
                                  primary
                                  style={{ width: '20%', marginLeft: 'auto' }}
                                >
                                  {getDescription('DOMAINS', 813)}
                                </Button>
                              ) : (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                  <Button
                                    id="btnCancel"
                                    type="button"
                                    style={{ marginLeft: 'auto' }}
                                    onClick={async () => {
                                      setAddContact(false)
                                      personHandler.events.handleContactFields({ questionnaire, setFieldValue })
                                    }}
                                    primary
                                  >
                                    {getDescription('DOMAINS', 791)}
                                  </Button>
                                  <Button
                                    id="btnSaveContact"
                                    type="button"
                                    style={{ marginLeft: 'auto' }}
                                    onClick={() => {
                                      if (disableSaveContact) return;

                                      generalHandler.events.handleContactManagement({
                                        formikRef,
                                        mc,
                                        values,
                                        questionnaire,
                                        idPerson,
                                        idOperation,
                                        SECTIONS,
                                        contacts,
                                        getDescription,
                                        setFieldValue,
                                        callback: createContact,
                                        setFieldError,
                                        isUsernameAvailable
                                      })
                                    }}
                                    disabled={isBound}
                                    primary
                                  >
                                    {getDescription('DOMAINS', 846)}
                                  </Button>
                                </div>
                              )}
                            </HasPermission>
                          </ButtonContent>
                        </ButtonContainer>
                      )}
                    </>
                  )}
                </FormContainer>
              )}
              
              {/* Produtos */}
              {showProductPlansSection && (
                  <FormContainer
                    enumerate={1.1}
                    noTitlePadding
                    title={getDescription('DOMAINS', 771)}
                    hide={!generalHandler.events.sectionIsVisible({
                      sectionName: 'PRODUCT_PLAN',
                      questionnaire,
                      permissions,
                      currentModality: null,
                      ignoreVisibilityByModality: true,
                    })}
                  >
                    {productPlansGroup.map((questions, index) => (
                      <div key={`product-plan-${index}`} style={{ width: '100%' }}>
                        {index > 0 && questions && questions[0]?.mainGroup && (
                          <div style={{ width: '100%', borderBottom: 'solid 1px #53565A' }} />
                        )}
                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <p style={{ width: '20%', color: '#53565A', fontSize: '14px', fontWeight: '700', paddingRight: '20px' }}>
                            {questions && questions[0]?.answer}
                          </p>

                          <p style={{ width: '20%', maxWidth: '365px', color: '#53565A', fontSize: '14px', fontWeight: '700', paddingRight: '20px' }}>
                            {questions && questions[1]?.productPlanName}
                          </p>
                          <div style={{ width: '40%' }}>
                            <FormSection
                              setQuestionnaire={(questionnaire) =>
                                setProductPlansGroup(productPlansGroup.map((v, i) => (i === index ? questionnaire : v)))
                              }
                              sectionName="PRODUCT_PLAN"
                              sectionIndex={index}
                              disableAll={isBound}
                              idProduct={match.params.idProduct}
                              values={values}
                              errors={errors}
                              setFieldValue={setFieldValue}
                              setFieldError={setFieldError}
                              questionnaire={questions}
                              formikRef={formikRef}
                              permissions={permissions}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </FormContainer>
              )}

              {/* Informações do tomador */}
              {showBorrowerInfoSection && (
                  <FormContainer
                    enumerate={1.1}
                    noTitlePadding
                    title={getDescription('DOMAINS', 770)}
                    hide={!generalHandler.events.sectionIsVisible({
                      sectionName: 'BORROWER_INFO',
                      questionnaire,
                      permissions,
                      currentModality: null,
                      ignoreVisibilityByModality: true,
                    })}
                  >
                    <FormSection
                      setQuestionnaire={setQuestionnaire}
                      sectionName="BORROWER_INFO"
                      disableAll={isBound}
                      idProduct={match.params.idProduct}
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      setFieldError={setFieldError}
                      questionnaire={questionnaire}
                      ignoreModality
                      permissions={permissions}
                    />
                  </FormContainer>
              )}

              {/* Informações de usuário */}
              {idPerson && !addingUser && ['Part', 'User'].includes(personType) && (
                <FormContainer
                  enumerate={3}
                  noTitlePadding
                  title={getDescription('DOMAINS', 806)}
                  hide={!generalHandler.events.sectionIsVisible({
                    sectionName: 'PERSON_USER',
                    questionnaire,
                    permissions,
                    currentModality: null,
                    ignoreVisibilityByModality: true,
                  })}
                >
                  <Label fontSize={20} style={{ marginBottom: 15 }}>
                    {getDescription('DOMAINS', 807)}
                  </Label>
                  {users?.length > 0 ? (
                    <ResponsiveTable columns={components.userColumns(userColumnsProps)} data={users} formikRef={formikRef?.current} />
                  ) : (
                    <Label fontSize={15} style={{ marginBottom: 15 }}>
                      {getDescription('DOMAINS', 808)}
                    </Label>
                  )}
                  <ButtonContainer>
                    <ButtonContent>
                      <HasPermission permission={isNotDisable.current && !['User'].includes(personType) && !individual }>
                        <Button
                          id="btnAddUser"
                          type="button"
                          style={{ width: '20%', marginLeft: 'auto' }}
                          onClick={() => {
                            history.push(`/management/58/person/create/${idPerson}/add-user`);
                            window.location.reload();
                          }}
                          primary
                        >
                          {getDescription('DOMAINS', 804)}
                        </Button>
                      </HasPermission>
                    </ButtonContent>
                  </ButtonContainer>
                </FormContainer>
              )}

              {/* Autorização do uso dos dados (LGPD) */}
              <FormSection
                setQuestionnaire={setQuestionnaire}
                sectionName="LGPD"
                disableAll={isBound}
                idProduct={match.params.idProduct}
                values={values}
                errors={errors}
                setFieldValue={setFieldValue}
                setFieldError={setFieldError}
                questionnaire={questionnaire}
                ignoreModality
                permissions={permissions}
              />
            </Form>

            {questionnaire?.length > 0 && (
              <ButtonContainer>
                {/* Voltar */}
                <Button forth onClick={() => history.goBack()}>
                  &lt; {getDescription('DOMAINS', 758)}
                </Button>

                {/* Criar Login */}
                <HasPermission permission={individual && personType !== 'User'}>
                  <Button id="btnSave" type="button" onClick={() => handleCreateLogin()} primary>
                    {getDescription('DOMAINS', 1068)}
                  </Button>
                </HasPermission>

                {/* Salvar */}
                <HasPermission permission={isNotDisable.current}>
                  <Button
                    id="btnSave"
                    type="button"
                    onClick={() => {
                      if (disableSaveContact) return;

                      generalHandler.events.handleSave({
                        values,
                        questionnaire,
                        idPerson: match.params.idPerson,
                        idOperation: match.params.idOperation,
                        idOperationParent: operation?.idOperationParent,
                        SECTIONS,
                        contacts,
                        productPlansGroup,
                        isDraft: false,
                        getDescription,
                        sentUpdateAdminOperation,
                        useUpdateAdminOperationRequest,
                        mc,
                        formikRef,
                        history,
                        addingUser,
                        idUser: user?.idUser,
                        userParentInfo: {
                          userPersonParent: match.params.idPerson,
                        },
                        save: true,
                        isCreating,
                        isUsernameAvailable,
                        setFieldError
                      })
                    }
                    }
                    primary
                  >
                    {getDescription('DOMAINS', 759)}
                  </Button>
                </HasPermission>
              </ButtonContainer>
            )}
          </Layout>
        )}
      </Formik>
    </>
  );
}
